/**
 * Tiny relative-time formatter (no extra dep).
 * Returns e.g. "för 3 min sedan", "för 2 dagar sedan".
 */
export function formatRelative(iso) {
  if (!iso) return "";
  const d = typeof iso === "string" ? new Date(iso) : iso;
  const diff = (Date.now() - d.getTime()) / 1000;
  if (diff < 60) return "för en stund sedan";
  if (diff < 3600) return `för ${Math.floor(diff / 60)} min sedan`;
  if (diff < 86400) return `för ${Math.floor(diff / 3600)} h sedan`;
  if (diff < 7 * 86400) return `för ${Math.floor(diff / 86400)} d sedan`;
  return d.toLocaleDateString();
}
